import { request, setToken, startLogin } from './http';

/* Существующее API. Новых механизмов дэшборд не вводит:
   вход — тот же, что в основном приложении, данные — читающие эндпоинты
   из ветки admin-dashboard-api (docs/admin-dashboard.md в бэкенде). */

const DASHBOARD = '/api/v1/admin/dashboard';

export const api = {
  auth: {
    /** Уводит на страницу входа Keycloak через бэкенд. */
    login: startLogin,

    /**
     * Кто вошёл. Роль администратора — это глобальная роль ADMIN,
     * тот же признак, по которому пускает бэкенд.
     */
    me: async () => {
      const me = await request('/api/v1/me');
      return {
        email: me.email,
        name: [me.firstName, me.lastName].filter(Boolean).join(' ') || me.email,
        role: me.role,
        isAdmin: me.role === 'ADMIN',
      };
    },

    logout: async () => {
      try {
        await request('/api/v1/auth/logout', { method: 'POST' });
      } finally {
        setToken(null);
      }
    },
  },

  summary: (params) => request(`${DASHBOARD}/summary`, { params }),
  series: (params) => request(`${DASHBOARD}/series`, { params }),

  workspaces: (params) => request(`${DASHBOARD}/workspaces`, { params }),
  workspace: (id) => request(`${DASHBOARD}/workspaces/${id}`),
  workspaceSeries: (id, params) => request(`${DASHBOARD}/series`, { params: { ...params, workspaceId: id } }),


  users: (params) => request(`${DASHBOARD}/users`, { params }),
  user: (id) => request(`${DASHBOARD}/users/${id}`),

  revenue: () => request(`${DASHBOARD}/revenue`),
  payments: (params) => request(`${DASHBOARD}/payments`, { params }),
  trialCohorts: () => request(`${DASHBOARD}/trials/cohorts`),
  renewals: (params) => request(`${DASHBOARD}/renewals`, { params }),

  content: (params) => request(`${DASHBOARD}/content`, { params }),

  /* Действия. Все — существующие эндпоинты, новых ради админки не заводилось. */
  actions: {
    /**
     * Смена тарифа: назначается новая подписка на выбранную цену тарифа.
     * Эндпоинт тот же, которым пользуется само приложение; администратору
     * он разрешён для любой организации.
     */
    assignPlan: (workspaceId, planVersionPriceId) =>
      request(`/api/v1/organization/${workspaceId}/subscription`, {
        method: 'POST',
        body: { planVersionPriceId, autoRenew: true, startDate: new Date().toISOString().slice(0, 10) },
      }),

    setSubscriptionStatus: (subscriptionId, status) =>
      request(`/api/v1/admin/organization/subscription/${subscriptionId}/status`, {
        method: 'PUT',
        body: { status },
      }),

    deleteSubscription: (subscriptionId) =>
      request(`/api/v1/admin/organization/subscription/${subscriptionId}`, { method: 'DELETE' }),

    blockUser: (userId, reason) =>
      request(`/api/v1/admin/user/${userId}/block`, { method: 'POST', body: { reason } }),

    unblockUser: (userId) => request(`/api/v1/admin/user/${userId}/unblock`, { method: 'POST' }),

    resetTrial: (userId) => request(`/api/v1/admin/user/${userId}/trial/reset`, { method: 'POST' }),
  },

  /* Ниже — существующие админские эндпоинты, которые были и раньше. */
  plans: () => request('/api/v1/admin/plan'),

  /* Какие тарифы реально показаны на сайте. Берём у самой витрины, а не из
     флага в админском списке: тот сейчас всегда приходит false — в маппере
     бэкенда поле isPublished не сопоставляется (см. docs/admin-dashboard.md). */
  publicPlans: () => request('/api/v1/public/plan'),
  runJob: (key) => request(`/api/v1/admin/scheduler/${key}`, { method: 'POST' }),
};
